import dayjs from 'dayjs';

export const loadScript = (src) => {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve; // 加载成功
        script.onerror = reject; // 加载失败
        document.head.appendChild(script);
    });
}

export const saveData = (key, data) => {
    localStorage.setItem(key, data);
}

export const delData = (key) => {
    localStorage.removeItem(key);
}

// 读取数据
export const readData = (key) => {
    // 从localStorage中读取数据
    const dataString = localStorage.getItem(key);
    // 如果存在数据则将字符串转换回对象，否则返回null
    return dataString;
}

export const jumpTo = (t, y, p, q) => {
    t.$router.push({ name: y, params: p, query: q }, () => { }, () => { });
}

export const initTime = (str,format='YYYY-MM-DD HH:mm:ss') => {
    return dayjs(str).format(format);
}

export const formatTimeAgo = (date) => {
    if (typeof date === 'string') date = new Date(date);
    const now = new Date();
    const diffMs = now - date; // 时间差（毫秒）
    const diffSeconds = Math.floor(diffMs / 1000);
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const diffMonths = (now.getFullYear() - date.getFullYear()) * 12
        + (now.getMonth() - date.getMonth());
    // 处理未来时间直接返回格式化日期
    if (diffMs < 0) {
        return initTime(date);
    }
    // 分级判断时间差
    if (diffMonths > 3) {
        return initTime(date);
    } else if (diffDays > 31) {
        return `${diffMonths}月前`;
    } else if (diffDays > 0) {
        return `${diffDays}天前`;
    } else if (diffHours > 0) {
        return `${diffHours}小时前`;
    } else if (diffMinutes > 0) {
        return `${diffMinutes}分钟前`;
    } else {
        return `${diffSeconds}秒前`;
    }
}